const NoFavouritesIcon = (props) => (
  <svg
    width={623}
    height={623}
    viewBox='0 0 623 623'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g filter='url(#filter0_f_1457_87794)'>
      <circle cx={311.5} cy={311.5} r={161.177} fill='white' />
    </g>
    <circle
      cx={311.5}
      cy={311.5}
      r={178.5}
      fill='#FCEBEB'
      stroke='white'
      strokeWidth={12}
    />
    <mask
      id='mask0_1457_87794'
      style={{
        maskType: 'alpha',
      }}
      maskUnits='userSpaceOnUse'
      x={150}
      y={150}
      width={323}
      height={323}
    >
      <circle cx={311.5} cy={311.5} r={161.177} fill='white' />
    </mask>
    <g mask='url(#mask0_1457_87794)'>
      <path
        d='M452.318 314.447C444.46 354.901 412.995 391.868 358.792 424.418C334.182 439.183 308.134 451.407 281.05 460.901C279.301 461.462 277.439 461.573 275.637 461.223C273.834 460.872 272.149 460.073 270.738 458.898C265.669 454.621 148.29 354.03 166.755 258.974C169.51 244.743 176.044 231.515 185.67 220.676C195.296 209.838 207.66 201.788 221.467 197.372C235.274 192.955 250.014 192.334 264.144 195.573C278.273 198.812 291.271 205.793 301.775 215.783C302.351 216.345 302.793 217.029 303.07 217.785C303.346 218.54 303.45 219.348 303.373 220.149C303.297 220.95 303.041 221.724 302.627 222.413C302.212 223.103 301.648 223.69 300.976 224.133L272.556 243.308C270.193 244.906 268.561 247.377 268.017 250.177C267.473 252.978 268.062 255.88 269.654 258.247L306.324 312.428L282.616 328.539C281.431 329.318 280.415 330.326 279.625 331.504C278.836 332.682 278.291 334.006 278.02 335.397C277.75 336.789 277.76 338.221 278.051 339.609C278.342 340.996 278.907 342.312 279.714 343.478C281.31 345.806 283.756 347.414 286.526 347.957C289.337 348.49 292.246 347.926 294.653 346.38L327.335 324.329C329.698 322.731 331.331 320.26 331.875 317.46C332.419 314.659 331.83 311.757 330.237 309.39L293.593 255.077L327.829 232.094C336.596 226.108 346.469 221.93 356.87 219.804C367.271 217.679 377.991 217.648 388.404 219.714C409.442 223.801 427.995 236.078 439.981 253.843C451.967 271.609 456.405 293.409 452.318 314.447Z'
        fill='white'
      />
      <path
        d='M453.435 314.664C445.577 355.119 415.101 392.278 362.847 425.206C339.122 440.143 314.038 452.555 287.982 462.248C286.3 462.822 284.513 462.948 282.787 462.612C281.06 462.277 279.45 461.492 278.106 460.33C273.277 456.099 161.473 356.592 179.938 261.536C182.694 247.304 189.066 234.045 198.386 223.147C207.706 212.249 219.63 204.114 232.91 199.595C246.189 195.076 260.335 194.339 273.863 197.462C287.392 200.584 299.805 207.451 309.802 217.343C310.35 217.899 310.769 218.579 311.028 219.331C311.287 220.083 311.381 220.889 311.301 221.69C311.221 222.49 310.97 223.265 310.567 223.956C310.163 224.648 309.618 225.239 308.97 225.687L281.556 245.056C279.276 246.671 277.69 249.151 277.146 251.951C276.602 254.752 277.144 257.645 278.654 259.996L313.402 313.803L290.531 330.077C289.389 330.864 288.405 331.879 287.639 333.061C286.873 334.244 286.339 335.57 286.068 336.961C285.798 338.353 285.797 339.783 286.065 341.166C286.333 342.549 286.865 343.858 287.629 345.016C289.142 347.328 291.476 348.914 294.129 349.434C296.821 349.945 299.616 349.358 301.937 347.795L333.463 325.52C335.743 323.906 337.328 321.426 337.872 318.625C338.416 315.825 337.874 312.932 336.365 310.581L301.643 256.641L334.666 233.422C343.124 227.376 352.628 223.127 362.622 220.922C372.616 218.718 382.9 218.603 392.873 220.583C413.022 224.497 430.722 236.608 442.08 254.252C453.437 271.895 457.522 293.626 453.435 314.664Z'
        fill='url(#paint0_linear_1457_87794)'
      />
      <mask
        id='mask1_1457_87794'
        style={{
          maskType: 'alpha',
        }}
        maskUnits='userSpaceOnUse'
        x={112}
        y={134}
        width={391}
        height={403}
      >
        <path
          d='M453.435 314.664C445.577 355.119 415.101 392.278 362.847 425.206C339.122 440.143 314.038 452.555 287.982 462.248C286.3 462.822 284.513 462.948 282.787 462.612C281.06 462.277 279.45 461.492 278.106 460.33C273.277 456.099 161.473 356.592 179.938 261.536C182.694 247.304 189.066 234.045 198.386 223.147C207.706 212.249 219.63 204.114 232.91 199.595C246.189 195.076 260.335 194.339 273.863 197.462C287.392 200.584 299.805 207.451 309.802 217.343C310.35 217.899 310.769 218.579 311.028 219.331C311.287 220.083 311.381 220.889 311.301 221.69C311.221 222.49 310.97 223.265 310.567 223.956C310.163 224.648 309.618 225.239 308.97 225.687L281.556 245.056C279.276 246.671 277.69 249.151 277.146 251.951C276.602 254.752 277.144 257.645 278.654 259.996L313.402 313.803L290.531 330.077C289.389 330.864 288.405 331.879 287.639 333.061C286.873 334.244 286.339 335.57 286.068 336.961C285.798 338.353 285.797 339.783 286.065 341.166C286.333 342.549 286.865 343.858 287.629 345.016C289.142 347.328 291.476 348.914 294.129 349.434C296.821 349.945 299.616 349.358 301.937 347.795L333.463 325.52C335.743 323.906 337.328 321.426 337.872 318.625C338.416 315.825 337.874 312.932 336.365 310.581L301.643 256.641L334.666 233.422C343.124 227.376 352.628 223.127 362.622 220.922C372.616 218.718 382.9 218.603 392.873 220.583C413.022 224.497 430.722 236.608 442.08 254.252C453.437 271.895 457.522 293.626 453.435 314.664Z'
          fill='url(#paint1_linear_1457_87794)'
        />
      </mask>
      <g mask='url(#mask1_1457_87794)'>
        <g filter='url(#filter1_f_1457_87794)'>
          <ellipse
            cx={383.396}
            cy={258.349}
            rx={34.5155}
            ry={59.3248}
            transform='rotate(-79.826 383.396 258.349)'
            fill='white'
          />
        </g>
        <g filter='url(#filter2_f_1457_87794)'>
          <ellipse
            cx={253.932}
            cy={225.628}
            rx={27.3475}
            ry={40.6981}
            transform='rotate(-79.826 253.932 225.628)'
            fill='white'
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id='filter0_f_1457_87794'
        x={0.322754}
        y={0.323242}
        width={622.354}
        height={622.354}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          stdDeviation={75}
          result='effect1_foregroundBlur_1457_87794'
        />
      </filter>
      <filter
        id='filter1_f_1457_87794'
        x={244.682}
        y={142.787}
        width={277.428}
        height={231.124}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          stdDeviation={40}
          result='effect1_foregroundBlur_1457_87794'
        />
      </filter>
      <filter
        id='filter2_f_1457_87794'
        x={133.58}
        y={117.76}
        width={240.705}
        height={215.736}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          stdDeviation={40}
          result='effect1_foregroundBlur_1457_87794'
        />
      </filter>
      <linearGradient
        id='paint0_linear_1457_87794'
        x1={332.105}
        y1={208.729}
        x2={282.787}
        y2={462.612}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F00909' />
        <stop offset={1} stopColor='#F00909' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1457_87794'
        x1={332.105}
        y1={208.729}
        x2={282.787}
        y2={462.612}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F00909' />
        <stop offset={1} stopColor='#F00909' />
      </linearGradient>
    </defs>
  </svg>
);
export default NoFavouritesIcon;
